import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
export var footer = /*#__PURE__*/css("position:relative;height:60px;display:flex;justify-content:space-between;align-items:center;z-index:1000;background:", tokens.colors.neutral.surface.default, ";");
export var body = {
  name: "15id9fj",
  styles: "display:flex;justify-content:flex-end;width:100%;height:40px;padding:0 15px;"
};